/**
 * Public GET /links may return a masked recipient (e.g. r***@example.com).
 * Never treat that as a login / Cognito / OTP destination address.
 */
export const isMaskedEmail = (email?: string | null): boolean => (
    typeof email === 'string'
    && email.includes('@')
    && email.includes('*')
);

export default isMaskedEmail;
